// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1ewGc","notes":"Notes_notes__15A38"};